function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.currentSrc || image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function createOverlay(image) {
  const overlay = document.createElement('div');
  prepareOverlay(overlay, image);
  image.parentElement.insertBefore(overlay, image);
  return overlay;
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const rect = image.getBoundingClientRect();
  if (!rect.width || !rect.height) return;

  const x = Math.max(0, Math.min(rect.width, event.clientX - rect.left));
  const y = Math.max(0, Math.min(rect.height, event.clientY - rect.top));
  const xPercent = (x / rect.width) * 100;
  const yPercent = (y / rect.height) * 100;

  overlay.style.backgroundPosition = `${xPercent}% ${yPercent}%`;
  overlay.style.backgroundSize = `${rect.width * zoomRatio}px auto`;
  overlay.style.backgroundRepeat = 'no-repeat';
}

function enableZoomOnHover(zoomRatio) {
  const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (!supportsHover) return;

  const openers = document.querySelectorAll('.product__modal-opener--image');

  openers.forEach((opener) => {
    const image = opener.querySelector('.image-magnify-hover');
    if (!image || opener.dataset.gemormHoverZoom === 'true') return;

    opener.dataset.gemormHoverZoom = 'true';
    let overlay = null;

    opener.addEventListener('mouseenter', (event) => {
      if (overlay) return;
      overlay = createOverlay(image);
      moveWithHover(image, overlay, event, zoomRatio);
    });

    opener.addEventListener('mousemove', (event) => {
      if (!overlay) return;
      moveWithHover(image, overlay, event, zoomRatio);
    });

    opener.addEventListener('mouseleave', () => {
      if (!overlay) return;
      overlay.remove();
      overlay = null;
    });
  });
}

enableZoomOnHover(2);

document.addEventListener('shopify:section:load', () => enableZoomOnHover(2));
